import store from "state/store";
import {
  showUpdateNotification,
  hideUpdateNotification
} from "state/ui/updateNotification/updateNotificationActions";

class ApplicationUpdateNotifier {
  static async dispatchNotification() {
    // Automatically refresh the application when an update is available by
    // asking the waiting worker (or soon-to-be waiting worker) to skip waiting.
    try {
      if (!("serviceWorker" in navigator)) return;

      const sendSkipWaiting = worker => {
        try {
          worker && worker.postMessage({ type: "SKIP_WAITING" });
        } catch (e) {
          // no-op
        }
      };

      const registration = await navigator.serviceWorker.getRegistration();
      if (!registration) return;

      if (registration.waiting) {
        sendSkipWaiting(registration.waiting);
      } else {
        // If the new worker is still installing, wait for it to be installed
        const listenInstalling = installing => {
          if (!installing) return;
          const onStateChange = () => {
            if (installing.state === "installed") {
              sendSkipWaiting(installing);
              installing.removeEventListener("statechange", onStateChange);
            }
          };
          installing.addEventListener("statechange", onStateChange);
        };

        // Listen for an update to be found and then hook the installing worker
        if (registration.addEventListener) {
          registration.addEventListener("updatefound", () =>
            listenInstalling(registration.installing)
          );
        } else {
          // Fallback for environments without addEventListener on registration
          registration.onupdatefound = () =>
            listenInstalling(registration.installing);
        }

        // Hook existing installing worker if present
        listenInstalling(registration.installing);

        // Nudge the browser to check for updates right now
        try {
          await registration.update();
        } catch (e) {}

        // As a safety net, re-check shortly and send to waiting if now present
        setTimeout(async () => {
          try {
            const reg = await navigator.serviceWorker.getRegistration();
            if (reg && reg.waiting) sendSkipWaiting(reg.waiting);
          } catch (e) {}
        }, 2000);
      }
    } finally {
      // after triggering the update we want to stop the notification happening more than once
      store.dispatch(hideUpdateNotification());
    }
  }

  static flagNotificationForDispatch() {
    store.dispatch(showUpdateNotification());
  }
}

export default ApplicationUpdateNotifier;
